@let hasBundleItem = !!bundleItem();
@let selectedForPax = selectedForPassenger();
@let paxId = passenger().id;
@let overlaps = serviceOverlaps();
@let bundleServices = constituents();
@let button = buttonConfig();

<div
  class="pr-medium surface-primary rounded-large elevation-level-1"
  [attr.data-testid]="'ancillary-bundle-passenger-' + paxId"
>
  <div class="flex flex--space-between flex--middle ms-medium-b">
    <div class="flex flex--middle">
      <h4 #passengerHeading tabindex="-1" class="font-title-medium text-icon-primary">
        {{ passengerName() }}
      </h4>
    </div>
    <fcom-button
      [attr.data-testid]="'ancillary-bundle-selection-btn-' + paxId"
      [text]="button.textKey | finLocalization"
      [icon]="button.icon"
      [theme]="ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
      [disabled]="button.disabled"
      (clickBtn)="toggleBundle()"
    />
  </div>

  @if (overlaps.showNotification && hasBundleItem) {
    <fin-service-overlap-notification
      class="block ms-small-b"
      [category]="category()"
      [overlappingServices]="overlaps.services"
      [fragmentId]="fragmentId()"
      (continueSelection)="continueToSelection()"
      (cancelSelection)="keepExistingSelection()"
    />
  }

  @if (hasBundleItem) {
    <div class="bundle-services flex flex--nowrap flex--space-between">
      <fin-bundle-service-card [service]="bundleServices[0]" [inCart]="selectedForPax" />
      <div class="bundle-services__plus flex flex--shrink0 flex--center flex--middle">
        <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.PLUS" />
      </div>
      <fin-bundle-service-card [service]="bundleServices[1]" [inCart]="selectedForPax" />
      <div
        class="font-title-small text-icon-accent ps-medium rounded-large flex flex--column flex--end flex--align-end dashed-border-secondary"
        [class.dashed-box]="!selectedForPax"
        [class.surface-secondary]="selectedForPax"
        [attr.data-testid]="'ancillary-bundle-price-' + paxId"
      >
        {{ bundleItem()?.totalPrice | finPrice }}
      </div>
    </div>
  } @else {
    <fcom-notification
      class="block"
      [attr.data-testid]="'ancillary-bundle-unavailable-' + paxId"
      [theme]="NotificationTheme.INFO"
      [scale]="NotificationScale.SMALL"
    >
      <span>{{ 'ancillaries.bundle.unavailableBundle' | finLocalization }}</span>
    </fcom-notification>
  }
</div>
